import type { SVGProps } from "react";
import { memo } from "react";
const ProfessionalServices = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M60.052 56.359a1 1 0 0 0-.287.885l1.251 7.293-6.551-3.443a.99.99 0 0 0-.93 0l-6.55 3.443 1.251-7.293a1 1 0 0 0-.288-.885l-5.298-5.165 7.322-1.064a1 1 0 0 0 .753-.547L54 42.947l3.276 6.636c.145.295.426.5.753.547l7.322 1.064zm8.399-6.172a1 1 0 0 0-.807-.681l-8.808-1.28-3.939-7.981c-.336-.682-1.457-.682-1.793 0l-3.94 7.981-8.807 1.28a1.002 1.002 0 0 0-.555 1.706l6.374 6.212-1.505 8.772a1 1 0 0 0 1.45 1.055L54 63.109l7.879 4.142a1.01 1.01 0 0 0 1.053-.077 1 1 0 0 0 .397-.978l-1.505-8.772 6.374-6.212a1 1 0 0 0 .253-1.025m-45.962-24.14C22.489 19.404 27.894 14 34.537 14s12.046 5.404 12.046 12.047-5.403 12.048-12.046 12.048-12.048-5.404-12.048-12.048M34.5 40.827c3.879 0 7.681 1.104 10.993 3.192.647.406 1.281.856 1.886 1.335l1.242-1.567a24 24 0 0 0-2.061-1.461 22.7 22.7 0 0 0-7.44-3.014c5.499-1.907 9.463-7.125 9.463-13.265C48.583 18.302 42.282 12 34.537 12c-7.746 0-14.048 6.302-14.048 14.047 0 6.129 3.953 11.34 9.436 13.254C19.151 41.547 11 51.565 11 63.549v1h31v-2H13.021c.497-12.066 9.941-21.722 21.479-21.722"
      />
    </g>
  </svg>
);
const Memo = memo(ProfessionalServices);
export default Memo;
